module.exports = __webpack_public_path__ + "img/Previous.c38cfad2.svg";